import { FC } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { SortableContainer, SortableElement, SortEndHandler } from 'react-sortable-hoc';
import { StepGrid, NewRuleset } from '.';
import { State as CampaignState } from 'entities/lifecycle/lifeCycle';

const GlobalSortingStyle = createGlobalStyle`
  .sorting {
    list-style-type: none;
    z-index: 11;
  }
`;

const StyledRulesets = styled.ul`
  overflow-x: auto;
  display: flex;
  flex-wrap: nowrap;
  padding: 4.5rem 4rem;
  background-color: ${({ theme }) => theme.vars.newColor.darkGS2};
  list-style-type: none;
  height: 100%;
  margin-bottom: 0;
  width: calc(100vw - 400px);
  ::-webkit-scrollbar {
    width: 10px;
    &-track {
      background-color: ${({ theme }) => theme.vars.newColor.darkGS3};
    }
    &-thumb {
      background-color: #fff;
      :hover {
        background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
      }
    }
  }
`;

const StyledRulesetListItem = styled.li`
  width: 36rem;
  margin-right: 4rem;
`;

interface IRulesetListProps {
  onSortEnd: SortEndHandler;
  rulesetIds: string[];
  campaignState: CampaignState;
}

export const SortableRuleset = SortableElement(
  ({ id, sortIndex, status }: { id: string; sortIndex: number; status: CampaignState }) => (
    <StyledRulesetListItem key={id} data-testid="RulesetListItem">
      <StepGrid rulesetId={id} index={sortIndex} campaignState={status} />
    </StyledRulesetListItem>
  ),
);

export const SortableRulesetList = SortableContainer(
  ({ rulesetIds, status }: { rulesetIds: string[]; status: CampaignState }) => (
    <>
      <GlobalSortingStyle />
      <StyledRulesets data-testid="RulesetList">
        {rulesetIds.map((id, index) => (
          <SortableRuleset key={`item-${id}`} index={index} sortIndex={index} id={id} status={status} />
        ))}

        <StyledRulesetListItem>
          <NewRuleset />
        </StyledRulesetListItem>
      </StyledRulesets>
    </>
  ),
);

const RulesetList: FC<IRulesetListProps> = props => (
  <SortableRulesetList
    rulesetIds={props.rulesetIds}
    axis="x"
    helperClass="sorting"
    useDragHandle={true}
    onSortEnd={props.onSortEnd}
    status={props.campaignState}
  />
);

export default RulesetList;
